// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"c4795615e75b3e054e14","524":"6761e71a322e361e40d4","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};